$(document).ready(function () {
    $('.row.image-bar.slick-slider.mobile-image-gallery').hide();
    if ($(window).width() < 768) {
        $('.row.image-bar.slick-slider.mobile-image-gallery').show();
        $('.row.image-bar.desktop-image-gallery').hide();
      
          $('.slick-slider').slick({
              infinite: true,
              dots: true,
              arrows: true,
              responsive: [
                  {
                      breakpoint: 991,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                      },
                  },
                  {
                      breakpoint: 575,
                      settings: {
                          slidesToShow: 2,
                          slidesToScroll: 2,
                      },
                  },
              ],
          });
      
        
          $('.slick-slider-news').slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
              responsive: [
                  {
                      breakpoint: 991,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '50px'
                      },
                  }
              ],
          });
      
      }
    
});

